import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MissionPartnerViewTalentComponent } from "./mission-partner-view-talent.component";
import { AccountCommentsModule } from "../../../../../../../common-ui/src/lib/account-comments/account-comments.module";
import { AdminTalentDataspacesModule } from "../../../../common-componnets/admin-talent-dataspaces/admin-talent-dataspaces.module";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzGridModule } from "ng-zorro-antd/grid";
import { ProfilePreviewModule } from "../../../../common-componnets/profile-view/profile-preview.module";
import { TranslateModule } from "@ngx-translate/core";
import { CreateConversationDialogModule } from "../../../../common-componnets/create-conversation-dialog/create-conversation-dialog.module";

@NgModule({
  declarations: [MissionPartnerViewTalentComponent],
  imports: [
    CommonModule,
    AccountCommentsModule,
    AdminTalentDataspacesModule,
    CreateConversationDialogModule,
    NzCardModule,
    NzGridModule,
    ProfilePreviewModule,
    TranslateModule,
  ],
})
export class MissionPartnerViewTalentModule {}
